import { Breakpoints, BreakpointNames } from './types';
import { breakpointSizes } from './breakpointSizes';

export const breakpoints = [
  breakpointSizes.sm, // 0
  breakpointSizes.md, // 1
  breakpointSizes.lg, // 2
  breakpointSizes.xl, // 3
  breakpointSizes.xxl, // 4
];

export const space = [
  0, // 0
  4, // 1
  8, // 2
  16, // 3
  24, // 4
  32, // 5
  40, // 6
  64, // 7
];

export const breakpointsMapFunc = ({ breakpoints: breakpointsFromTheme }: any): Breakpoints => {
  const usedBreakpoints = breakpointsFromTheme ? breakpointsFromTheme : breakpoints;

  return {
    [BreakpointNames.sm]: usedBreakpoints[0],
    [BreakpointNames.md]: usedBreakpoints[1],
    [BreakpointNames.lg]: usedBreakpoints[2],
    [BreakpointNames.xl]: usedBreakpoints[3],
    [BreakpointNames.xxl]: usedBreakpoints[4],
  };
};

export const grid = {
  breakpoints,
  space,
};
